

$(document).ready(function() {

  $('body').bind('keyup, keydown, change','.wallpaper-calculator input',function(e){
    e.preventDefault();
    var wall_width = parseFloat($('#wall-width').val());
    var wall_height = parseFloat($('#wall-height').val());
    var roll_width = parseFloat($('#roll-width').val());
    var roll_length = parseFloat($('#roll-length').val());
    var pattern = parseFloat($('input[name="pattern"]:checked').val());
    if(pattern == 1){
      var pattern_r = parseFloat($('#pattern-repeatt').val());
      $('#pattern-repeatt').attr('disabled',false);
    }else{
      var pattern_r = parseFloat(1);
      $('#pattern-repeatt').attr('disabled',true);
    }
    var cal1 = Math.ceil((wall_width/roll_width)*100);
    var cal2 = Math.ceil((wall_height/pattern_r)*100);
    var cal3 = (cal2*pattern_r)/100;
    var cal4 = cal3*cal1;
    var final_val = Math.ceil(cal4/roll_length);
    
    if ($('#wall-width').val().trim() != '' && $('#wall-height').val().trim() != '' && $('#roll-width').val().trim() != '' && $('#roll-length').val().trim() != '') {
      if(parseInt($('input[name="pattern"]:checked').val()) == 1){
        if ($('#pattern-repeatt').val().trim() != ''){
          $('.roll_cnt').text(final_val);
        }else{
          $('.roll_cnt').text(0);
        }
      } else{
        $('.roll_cnt').text(final_val);
      }
    }else{
      $('.roll_cnt').text(0);
    }
  });
  
});

